import React, { useState } from "react";
import { Link } from "react-router-dom";
import { PASSWORD_RESET_1 } from "./AuthActions";

export default function ResetPassword() {
  const [email, setEmail] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    PASSWORD_RESET_1(email);
  };

  return (
    <div className="container" style={{ maxWidth: 500, padding: "48px 16px" }}>
      <header style={{ textAlign: "center", marginBottom: 48 }}>
        <h1 style={{ fontSize: "32px", fontWeight: "700", marginBottom: 16, color: "var(--ink)" }}>
          Reset Your Password
        </h1>
        <p style={{ color: "var(--muted)", fontSize: "16px", lineHeight: "1.5" }}>
          Enter your email address and we'll send you a link to reset your password.
        </p>
      </header>

      <form onSubmit={handleSubmit} style={{ marginBottom: 32 }}>
        <div style={{ marginBottom: 24 }}>
          <label
            htmlFor="email"
            style={{ display: "block", marginBottom: 8, fontWeight: "500", color: "var(--ink)", fontSize: "14px" }}
          >
            Email Address
          </label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="i7-input"
            style={{ width: "100%", padding: "12px 16px", borderRadius: "8px", fontSize: "16px", boxSizing: "border-box" }}
            placeholder="Enter your email address"
            autoComplete="email"
          />
        </div>

        <button
          type="submit"
          style={{
            width: "100%",
            padding: "14px 24px",
            backgroundColor: "var(--brand)",
            color: "white",
            border: "none",
            borderRadius: "8px",
            fontSize: "16px",
            fontWeight: "600",
            cursor: "pointer",
            transition: "background-color 0.2s ease",
          }}
          onMouseOver={(e) => { e.target.style.backgroundColor = "var(--brand-dark)"; }}
          onMouseOut={(e) => { e.target.style.backgroundColor = "var(--brand)"; }}
        >
          Send Reset Link
        </button>
      </form>

      <div style={{ textAlign: "center" }}>
        <p style={{ color: "var(--muted)", fontSize: "14px" }}>
          Remember your password?{" "}
          <Link to="/accounts/signin" style={{ color: "var(--brand)", textDecoration: "none", fontWeight: "500" }}>
            Sign in
          </Link>
        </p>
      </div>
    </div>
  );
}
